import { TextResources, ConfigData } from '../config/StoreLocatorTextResources';
import { STORELOCATORCOMPONENT } from '../components/storelocator.component';
import { MULTIPLELOCATIONSSERVICE } from './multiple.locations.service';
import { GOOGLEMAPSERVICE } from './google.map.service';
import { ROUTE } from './route.directions.service';
import { MARKER } from './google.marker.service';
import { URLSERVICE } from './url.service';

export class SearchService {
  /**
   * Propertys
   */
  searchHtmlElement: HTMLElement;
  inputField: HTMLInputElement;
  searchClear: boolean;
  cityLatLng: object;

  initSearchElement() {
    const searchHtmlElement = STORELOCATORCOMPONENT.mapContentHtmlElement.querySelector(
      'cwc-map-search',
    ) as HTMLElement;
    let searchElement: HTMLElement;

    if (searchHtmlElement) {
      searchElement = searchHtmlElement;
    } else {
      searchElement = this.createSearchElement();
    }
    this.searchHtmlElement = searchElement;

    return searchElement;
  }

  createSearchElement() {
    const inputField = document.createElement('input');
    inputField.type = 'input';
    inputField.placeholder = TextResources.resources['control'].search;
    inputField.className = 'pac-target-input';
    inputField.addEventListener('keydown', () => this.handleKeydown());

    // Create clear button
    const clearButton = document.createElement('button');
    clearButton.className = 'pac-target-button icon-close';
    clearButton.addEventListener('click', () => this.handleClear());

    // Create mylocation button
    const myLocationButton = document.createElement('button');
    myLocationButton.className = 'pac-target-button icon-location';
    myLocationButton.title = TextResources.resources['control'].current_location;
    myLocationButton.addEventListener('click', () => {
      if (ROUTE.directionsRenderer !== undefined) {
        ROUTE.resetDirectionsMap();
      }
      MARKER.deleteMarkers();
      MULTIPLELOCATIONSSERVICE.handleCurrentLocation();
      if (MULTIPLELOCATIONSSERVICE.backButton !== undefined) {
        MULTIPLELOCATIONSSERVICE.backButton.click();
      }
    });

    // Create buttons wrapper
    const buttonWrapper = document.createElement('div');
    buttonWrapper.className = 'pac-target-buttons';
    buttonWrapper.appendChild(clearButton);
    buttonWrapper.appendChild(myLocationButton);

    // Create search html element
    const searchHtmlElement = document.createElement('cwc-map-search');
    searchHtmlElement.appendChild(inputField);
    searchHtmlElement.appendChild(buttonWrapper);

    this.inputField = inputField;
    this.getGoogleAutocomplete();

    return searchHtmlElement;
  }

  /**
   * Handles keydown event on search input
   */
  handleKeydown() {
    this.searchClear = false;
    this.searchHtmlElement.querySelector<HTMLButtonElement>('button.icon-close').style['visibility'] = 'visible';
  }

  /**
   * Clears the search input field
   */
  handleClear() {
    this.searchClear = true;
    this.searchHtmlElement.querySelector<HTMLInputElement>('input.pac-target-input').value = '';
    this.searchHtmlElement.querySelector<HTMLButtonElement>('button.icon-close').style['visibility'] = 'hidden';
  }

  /**
   * Initialize Autocomplete using the GoogleMapService.
   * Autocomplete can be switched on optionally: this.autocomplete=true/false
   */
  getGoogleAutocomplete() {
    GOOGLEMAPSERVICE.initAutocomplete(this.inputField, (selectedPlace) => {
      if (
        ConfigData.data['urlLandingPage'] &&
        ConfigData.data['forceDisplaySearchFild'] &&
        selectedPlace.cityName !== null
      ) {
        URLSERVICE.redirectToLandingPage(selectedPlace.cityName);
        return;
      }

      if (selectedPlace.latitude !== null && selectedPlace.longitude !== null) {
        const geoCoords = {
          lat: selectedPlace.latitude,
          lng: selectedPlace.longitude,
        };

        STORELOCATORCOMPONENT.geoCoords = geoCoords;
        ROUTE.geoCoords = geoCoords;
        STORELOCATORCOMPONENT.sendLocationRequest(geoCoords);

        if (ConfigData.data['receiveParameters']) {
          URLSERVICE.updateParam(selectedPlace.cityName);
        }
      }
    });
  }
}

export const SEARCHSERVICE = new SearchService();
